import { Flex, IconInfo, Text, ThemeUIStyleObject } from "@powerledger/ui-component-lib";

export type UserMessageProps = {
  sx?: ThemeUIStyleObject;
  message: string;
  showInfoIcon?: boolean;
};

export const UserMessage = ({ sx, message, showInfoIcon = true }: UserMessageProps) => {
  return (
    <Flex
      sx={{
        background: "warning.50",
        padding: 2,
        borderRadius: 4,
        alignItems: "center",
        gap: 1,
        ...sx,
      }}
    >
      {showInfoIcon && (
        <IconInfo
          sx={{
            width: "20px",
            height: "20px",
          }}
          noSvgPositioning
          color={"primary.700"}
        />
      )}
      <Text
        sx={{
          fontSize: 1,
          fontWeight: 500,
          color: "textDark",
        }}
      >
        {message}
      </Text>
    </Flex>
  );
};
